import { getData } from './api';
import {
  AgentTask,
  AgentTaskEvent,
  AgentTaskListResponse,
  AgentTaskStats,
} from '../types/admin';

export interface ListAgentTasksParams {
  status?: string;
  agentName?: string;
  limit?: number;
  offset?: number;
}

export const adminApi = {
  getAdminStatus: (): Promise<{ isAdmin: boolean }> => getData<{ isAdmin: boolean }>('/auth/admin-status'),

  listAgentTasks: (params: ListAgentTasksParams = {}): Promise<AgentTaskListResponse> =>
    getData<AgentTaskListResponse>('/api/admin/agent-tasks', { params }),

  getAgentTask: (id: string): Promise<AgentTask> =>
    getData<AgentTask>(`/api/admin/agent-tasks/${id}`),

  getAgentTaskWithEvents: (id: string): Promise<AgentTask> =>
    getData<AgentTask>(`/api/admin/agent-tasks/${id}`, {
      params: { includeEvents: 'true' },
    }),

  getAgentTaskEvents: (id: string, options?: { eventType?: string }): Promise<AgentTaskEvent[]> =>
    getData<AgentTaskEvent[]>(`/api/admin/agent-tasks/${id}/events`, { params: options }),

  getAgentTaskStats: (since?: Date): Promise<AgentTaskStats> =>
    getData<AgentTaskStats>('/api/admin/agent-tasks/stats', {
      params: since ? { since: since.toISOString() } : {},
    }),
};
